import styled from 'styled-components'
// themes
import { colors } from 'themes/index'
// types
import { ThreadPrimitive } from '@assistant-ui/react'

export const ThreadWrapper = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

export const StyledThreadRoot = styled(ThreadPrimitive.Root)`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const StyledThreadViewport = styled(ThreadPrimitive.Viewport)`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.gray850};
    border-radius: 3px;
  }
`

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  text-align: center;
`

export const EmptyStateTitle = styled.p`
  font-size: 32px;
  font-weight: 600;
  color: ${colors.black};
  margin: 0;
`

export const EmptyStateSubtitle = styled.p`
  font-size: 20px;
  color: ${colors.gray380};
  margin: 0;
`

export const SummarizeButton = styled.button`
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  margin-top: 40px;
  padding: 6px 14px;
  border: 1px solid ${colors.purple300};
  border-radius: 12px;
  background: ${colors.purple300};
  color: ${colors.white100};
  font-size: 16px;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.03);
  }
`
